import type { PaginatedDataResponse, SearchParams } from '../api/types.js';

export const initialSearchParams = {
  itemsPerPage: 50,
  pageNumber: 1,
  search: '',
} satisfies SearchParams;

export const ROWS_PER_PAGE_OPTIONS = [
  initialSearchParams.itemsPerPage,
  100,
  200,
  400,
];

export const INFINITYISH = 10000;

export const DEFAULT_HEADER_CELLS_COUNT = 5;

export const getPaginatedDataPlaceholder = <T = Record<string, never>>(
  additional: T = {} as T,
) => {
  return {
    items: [],
    pageNumber: initialSearchParams.pageNumber,
    itemsPerPage: initialSearchParams.itemsPerPage,
    totalItems: 0,
    additional,
  } as const satisfies PaginatedDataResponse<unknown, T>;
};

export const ROW_HEIGHT = 40;
export const FIRST_CELL_WIDTH = 52;
